import { useContext } from "react";
import { PageNavigationContext, PageNavigator } from "../context/pageNavigation.context";

/**
 * A simple hook any component can call to grab the page-scroll function.
 * Returns the PageNavigator you provided in the nearest PageNavigationProvider.
 */
export function usePageNavigator(): PageNavigator {
    return useContext(PageNavigationContext);
}
